<template>
  <div>
    <a-page-header class="vd-gl-header-warp">
      <template slot="footer">
        <a-tabs :default-active-key="this.$route.path" @change="changePane">
          <a-tab-pane key="/book/detail/add" tab="添加推广员" />
          <a-tab-pane key="/book/detail/member" tab="推广员" />
          <a-tab-pane key="/book/detail/info" tab="收集信息" />
        </a-tabs>
      </template>
      <a-descriptions size="small" :column="1">
        <a-descriptions-item label="活动id">
          {{ id }}
        </a-descriptions-item>
        <a-descriptions-item label="小程序名称">
          {{ detail.item.name }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ detail.item.add_time }}
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ detail.item.remark }}
        </a-descriptions-item>
      </a-descriptions>
      <div class="vd-gl-statistic-group">
        <!-- 小程序状态 -->
        <a-statistic
          title="小程序状态"
          :value="detail.item.status === 1 ? '推广中' : '结束'"
          class="vd-gl-statistic"
        />
        <!-- 推广员数量 -->
        <a-statistic
          title="推广员"
          :value="detail.member_count"
          class="vd-gl-statistic"
        >
          <template slot="prefix">
            <a-icon type="user"></a-icon>
          </template>
        </a-statistic>
        <!-- 推广总量 -->
        <a-statistic
          title="总推广量"
          :value="detail.all_count"
          class="vd-gl-statistic"
        />
        <a-statistic
          title="新用户"
          :value="detail.new_count"
          class="vd-gl-statistic"
        />
        <a-statistic
          title="老用户"
          :value="detail.old_count"
          class="vd-gl-statistic"
        />
      </div>
    </a-page-header>

    <div class="vd-gl-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getBookDetail } from '@/api/book'

export default {
  name: 'ActivityDetail',
  data() {
    return {
      id: 0,
      detail: {
        item: {},
        status: 1,
        member_count: 0,
        all_count: 0,
        new_count: 0,
        old_count: 0,
      },
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getData()
  },
  methods: {
    getData() {
      getBookDetail({ id: this.id }).then((res) => {
        if (res['code'] === 1) {
          this.detail.item = res['item']
          this.detail.member_count = res['member_count']
          this.detail.all_count = res['all_count']
          this.detail.new_count = res['new_count']
          this.detail.old_count = res['old_count']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    setting() {},
    changePane(key) {
      this.$router.replace({
        path: key,
        query: { id: this.id },
      })
    },
  },
}
</script>

<style scoped></style>
